'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("SaisieBudgetCreationPopinController", function ($scope, $http, $translate, $session, $q, lovService, contextService, $authz, etatDetteService, $applications) {
  var reloadContext = function reloadContext() {
    contextService.refreshData();
  };
  etatDetteService.getOrInitParams().then(function (params) {
    $scope.plansComptables = _.map(params.plansComptablesAccessibles, function (plan) {
      return {
        id: plan.id,
        label: $translate("lov.plansComptables." + plan.id)
      };
    });
  });
  var compte = $session.getCompte();
  var parentBudget = $scope.parent;

  // tout type de compte qui peut avoir de la dette garantie doit etre inclu
  $scope.collectivite = $session.getCompte().typeCompte === 'EPCI' || $session.getCompte().typeCompte === 'COMMUNE' || $session.getCompte().typeCompte === 'METROPOLE_ET_COLLECTIVITE_TERRITORIALE' || $session.getCompte().typeCompte === 'DEPARTEMENT' || $session.getCompte().typeCompte === 'REGION' || $session.getCompte().typeCompte === 'SYNDICAT';
  $scope.referenceCIRILMaxLength = parentBudget == null ? 2 : 10;
  if (!$scope.edition) {
    $scope.budget = {
      children: [],
      compteId: parentBudget ? parentBudget.compteId : compte.id,
      // module subvention coché par défaut si on a le module subvention - seuls les budgets racines sont concernés
      moduleSubvention: parentBudget == null && $session.getCompte().moduleSubvention,
      // module subvention coché par défaut si on a le module dette - seuls les budgets racines sont concernés
      moduleDette: parentBudget == null && $applications.getApp("DETTE").isAllowed($session.getHabilitations()),
      compteBudgetAvecModuleDette: parentBudget == null && $applications.getApp("DETTE").isAllowed($session.getHabilitations()),
      compteBudgetAvecModuleSubvention: parentBudget == null && $session.getCompte().moduleSubvention
    };
  }
  var originalBudget = $scope.budget;
  var budget = $scope.budget = angular.copy(originalBudget);
  $scope.comptesLies = [{
    "id": compte.id,
    "nom": compte.nomClient
  }];
  _.each(compte.comptesLies, function (nom, id) {
    $scope.comptesLies.push({
      "id": id,
      "nom": nom
    });
  });
  $scope.aComptesLies = $session.possedeComptesLies();
  $scope.params = {
    budgetPrincipal: $scope.budget.type === 'PRINCIPAL'
  };
  $scope.$watch('params.budgetPrincipal', function () {
    if ($scope.params.budgetPrincipal) {
      $scope.budget.type = 'PRINCIPAL';
    } else {
      $scope.budget.type = null;
    }
  });
  $scope.saveBudget = function () {
    // validation
    $scope.errorMessage = null;
    if (_.isEmpty(budget.nom)) {
      $scope.errorMessage = $translate('saisie.budget.creationPopin.name_required');
      return;
    }
    // if (budget.type === 'PRINCIPAL' && _.isEmpty(budget.planComptable)) {
    //     $scope.errorMessage = $translate('saisie.budget.creationPopin.planComptable_required');
    //     return;
    // }

    var savePromise = null;

    // saving
    if ($scope.edition) {
      savePromise = $http.post("/rest/budgets/" + budget.id, budget);
    } else {
      savePromise = $http.post("/rest/budgets/new", budget, {
        params: {
          parentId: parentBudget && parentBudget.id || null
        }
      });
    }
    savePromise.then(function (response) {
      var validation = response.data;
      if (validation.valid) {
        $scope.$close(validation.result);
      } else {
        $scope.errorMessage = validation.errors[0].message;
      }
      reloadContext();
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/budget/gestionBudgets/budgetCreationPopin.js
// module id = 2680
// module chunks = 13